import {Component} from '@angular/core';
import {NavController, NavParams, ViewController} from 'ionic-angular';

/**
 * Generated class for the LobbyScreensaverPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-lobby-screensaver',
    templateUrl: 'lobby-screensaver.html',
})
export class LobbyScreensaverPage {

    appData: any;

    constructor(public navCtrl: NavController, public viewCtrl: ViewController, public navParams: NavParams) {
      this.appData = this.navParams.get('appData');
    }

    closeModal() {
        this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/lobby-screensaver/lobby-screensaver.ts